import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import {
    COURSE_SKIN,
    ISessionStat,
    COURSE_SESSION_LEARN_STATUS,
    SwitchNum,
    Second,
    PARTICIPATE_STATUS,
} from '@umu/umu-types';

export interface IGamificationInfo {
    skin_id: COURSE_SKIN;
    stat: ISessionStat;
    complete_point: number;
    has_interactive_point: SwitchNum;
    participate_status: {
        accept_submission_time: Second;
        refuse_submission_time: Second;
        participate_status: PARTICIPATE_STATUS;
    };
    beyond_ratio: number;
    point_isopen: SwitchNum;
    learn_status: COURSE_SESSION_LEARN_STATUS;
    quiz_cover_tips_content: string;
    is_re_exam: SwitchNum;
    participate_num: string;
}

export const getGamificationInfo = (elementId: string | number): Promise<IResponse<IGamificationInfo>> => {
    return fetchData(Api.GAMIFICATION_INFO, { element_id: elementId }).then((res: IResponse<IGamificationInfo>) => {
        return res;
    });
};
